import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Attachment18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5284 3.5323L3.53229 10.5284C2.47066 11.6064 2.46979 13.3906 3.53035 14.4697C4.60935 15.5301 6.39322 15.5294 7.47133 14.468L12.869 9.06034C13.2605 8.66766 13.2607 8.01251 12.8691 7.6198C12.4805 7.2312 11.829 7.23134 11.4405 7.62012L5.44032 13.6203L4.37966 12.5597L10.3795 6.55988C11.3449 5.59394 12.9746 5.6032 13.9305 6.55988C14.8983 7.53011 14.8989 9.14931 13.931 10.1197L8.5267 15.534C6.8714 17.1667 4.12859 17.1667 2.47331 15.534L2.46599 15.5267C0.833232 13.8715 0.833302 11.1286 2.46605 9.47332L2.46965 9.46966L9.4733 2.46604C11.1286 0.833269 13.8714 0.833288 15.5267 2.46605L15.5334 2.47274C16.6958 3.64863 17.084 5.43645 16.514 6.98855L15.106 6.47145C15.477 5.4611 15.2253 4.29738 14.47 3.53065C13.3909 2.46982 11.6066 2.47055 10.5284 3.5323Z'
      fill='currentColor'
    />
  </Svg>
);

Attachment18.displayName = 'Attachment18';
export default Attachment18;
